import React from 'react';
import { connect } from 'react-redux';
import styles from './footer.module.scss';
import instImg from '../../assets/instagram.png';
import LIImg from '../../assets/LI.png';
import gitImg from '../../assets/github.png';

const Footer = () => {
    const links = [
        { title: 'LinkedIn', href: 'https://es.linkedin.com/in/armangharibyan', icon: LIImg },
        { title: 'Github', href: 'https://github.com/ArmanGharibyan93', icon: gitImg },
        { title: 'Instagram', href: 'https://www.instagram.com/_arman_gharibyan_/', icon: instImg }
    ];

    return(
        <footer className={styles.container}>
            <div className={styles.copy}>Arman Gharibyan. Software developer focused on dependable product delivery.</div>
            <div className={styles.links}>
                {links.map((item) => (
                    <a key={item.title} title={item.title} href={item.href} rel="noreferrer" target="_blank" className={styles.link}>
                        <img className={styles.img} src={item.icon} alt={item.title} />
                    </a>
                ))}
            </div>
        </footer>
    )
}

const mapStateToProps = (state) => {
    return{
        words: state.main.words
    }
}

export default connect(mapStateToProps, {})(Footer)